export default __webpack_public_path__ + "static/media/150000_small_size.e3f32cce.png";